import { Routes } from '@angular/router';

import { ConfirmRegistrationGuard } from 'src/guards/confirm-registration.guard';
import { PagesGuard } from 'src/guards/pages.guard.ts';
import { AuthenticationGuard } from 'src/guards/authentication.guard';
import { DownloadGuard } from 'src/guards/download.guard';

import { OAuthCallbackComponent } from './oauth-callback/oauth-callback.component';
import { SsoAuthorizeComponent } from './sso-authorize/sso-authorize.component';
import { OAuthConsentComponent } from './oauth-consent/oauth-consent.component';

export const APP_ROUTES: Routes = [
  {
    // OAuth-Callback-Route: bewusst AUSSERHALB PagesGuard, damit Provider-Redirects
    // nicht ueber den Auth-Login-Flow laufen.
    path: 'oauth-callback',
    component: OAuthCallbackComponent,
  },
  {
    // SSO-Bestätigung für OIDC-Clients (LearningSuite): ebenfalls AUSSERHALB PagesGuard,
    // fehlender Login wird in der Komponente selbst (mit Rücksprung) behandelt.
    path: 'sso/authorize',
    component: SsoAuthorizeComponent,
  },
  {
    // Zustimmung für KI-Anwendungen am MCP-Dienst (LIPP-1500): wie sso/authorize außerhalb
    // PagesGuard, fehlender Login wird in der Komponente selbst (mit Rücksprung) behandelt.
    path: 'oauth/consent',
    component: OAuthConsentComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'confirm-registration',
    loadChildren: () =>
      import('./confirm-registration/confirm-registration.module').then(
        (m) => m.ConfirmRegistrationModule
      ),
    canActivate: [ConfirmRegistrationGuard],
  },
  {
    path: 'download',
    loadChildren: () =>
      import('./download/download.module').then((m) => m.DownloadModule),
    title: 'Download',
    canActivate: [DownloadGuard],
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./error/error.module').then((m) => m.ErrorModule),
    title: 'Error',
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./maintenance/maintenance.module').then(
        (m) => m.MaintenanceModule
      ),
    title: 'Maintenance',
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./payment/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [PagesGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
